//#region src/order_validation_mode.ts
let OrderValidationMode = /* @__PURE__ */ function(OrderValidationMode) {
	OrderValidationMode["Default"] = "default";
	OrderValidationMode["OnAdd"] = "on-add";
	OrderValidationMode["Background"] = "background";
	return OrderValidationMode;
}({});
//#endregion
export { OrderValidationMode };

//# sourceMappingURL=order_validation_mode.js.map